export enum DialogSize {
  small = "small",
  normal = "normal",
  large = "large",
  xlarge = "xlarge",
  xxlarge = "xxlarge",
}
